// extracted by mini-css-extract-plugin
export default {"image":"Employment_image__-fTE+"};